import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../state/authStore";
import TeamOnboardingGate from "./TeamOnboardingGate";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, deletedUntil, unavailable, checkAuth, _checked } = useAuthStore();
  const location = useLocation();

  // #1191: wait for the first check too. On the first render it hasn't started, and
  // redirecting then sent every signed-in deep link through the Login page.
  if (loading || (!_checked && !unavailable)) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <div className="spinner" style={{ width: 32, height: 32 }} />
      </div>
    );
  }

  if (!user) {
    if (unavailable) {
      return (
        <main style={{ maxWidth: 480, margin: "20vh auto", padding: 24 }}>
          <h1>Sign-in is temporarily unavailable</h1>
          <p>Your saved sign-in has been kept. Please try again in a few seconds.</p>
          <button type="button" onClick={() => void checkAuth(true)}>Retry</button>
        </main>
      );
    }
    // #398: an account just scheduled for deletion goes to sign-in with no returnTo,
    // so restoring it later doesn't send the person back to the delete form.
    if (deletedUntil) return <Navigate to="/login" replace />;
    // #1045: the router's location for this render; window.location may already be the
    // login URL when this renders again, which nested returnTo inside another login URL.
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <TeamOnboardingGate>{children}</TeamOnboardingGate>;
}
